import {
  CSQ_ADDON_DETAILS_CLICK,
  CSQ_MEALS_DETAILS_CLICK,
  CSQ_SUBSCRIPTION_DETAILS_CLICK,
} from '@/constants/analytics-events'

export const CSQ_EVENT_LISTENERS = {
  [`@${CSQ_ADDON_DETAILS_CLICK}.window`]() {
    const isOMDPage = document.querySelector(
      'div[x-data=programPanel][data-program-type=signature]',
    )
    isOMDPage &&
      window?.dataLayer?.push({
        event: 'open-omd-addon-details-flyout',
      })
  },
  [`@${CSQ_SUBSCRIPTION_DETAILS_CLICK}.window`]() {
    const isOMDPage = document.querySelector(
      'div[x-data=programPanel][data-program-type=signature]',
    )
    isOMDPage &&
      window?.dataLayer?.push({
        event: 'open-omd-subscription-details-flyout',
      })
  },
  [`@${CSQ_MEALS_DETAILS_CLICK}.window`]() {
    window?.dataLayer?.push({
      event: 'open-next-week-menu-flyout',
    })
  },
}
